import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

/** @deprecated Use `React Router hooks` instead */
export interface WithRouterProps {
  location: ReturnType<typeof useLocation>;
  params: Record<string, string>;
  navigate: ReturnType<typeof useNavigate>;
}

/** @deprecated Use `React Router hooks` instead */
export const withRouter = <Props extends WithRouterProps>(
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Component: React.ComponentType<Props>,
) => {
  return (props: Omit<Props, keyof WithRouterProps>) => {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();

    return (
      <Component {...(props as Props)} router={{ location, navigate, params }} />
      // <Component {...(props as Props)} location={location} params={params} navigate={navigate} />
    );
  };
};

// export const withRouter = (Component) => {
//   function ComponentWithRouterProp(props: JSX.IntrinsicAttributes) {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const params = useParams();
//     return <Component {...props} router={{ location, navigate, params }} />;
//   }
//   return ComponentWithRouterProp;
// };
